import { Banner } from '@cointracker/styleguide';
import { ReactNode, useContext } from 'react';
import { UserContext } from 'src/app/user/context';
import { PageNotFound } from 'src/pages/404';

export const ForbidViewAsTaxPro = ({ children }: { children: ReactNode }) => {
  const user = useContext(UserContext);
  if (user.isAuthenticated && user.isTaxProViewingClient) {
    return (
      <>
        <Banner closable={false} type="error">
          You do not have privileges to access this area.
        </Banner>
        <PageNotFound userIsAuthenticated={true} />
      </>
    );
  }
  return <>{children}</>;
};
